import React from "react";

type Props = {
  progress?: number;
  message?: string;
};

export default function Loading({ progress = 0, message = "Loading..." }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#000000]/60">
      <div className="bg-white/95 p-6 rounded-lg shadow-lg flex flex-col items-center w-[240px]">
        <div className="w-16 h-16 border-4 border-t-transparent border-blue-500 rounded-full animate-spin mb-4" />
        <div className="text-lg font-semibold mb-2">{message}</div>
        <div className="text-sm text-gray-600">{progress}%</div>
      </div>
    </div>
  );
}
